import {
  Box,
  Drawer,
  Tab,
  Tabs,
  Button,
  Chip,
  IconButton,
  Card,
  CardContent,
  Typography,
  DialogActions,
  Divider,
  DialogContent,
  Dialog,
} from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import CashPayment from "./payment/cash";
import CreditCardPayment from "./payment/creditcard";
import ChequePayment from "./payment/cheque";
import GiftCardPayment from "./payment/giftcard";
import { toast } from "react-toastify";
import { closeTableSessionAndPayAll, addCart } from "../../Services/CartApi";
import {
  calculateReceiptByTVA,
  convertCartsToCartItems,
  ImpressionTicket,
  buildReceiptCart,
} from "../../Helpers/Helpers";
import { PrintAction } from "../../Shared/Hardware/PrintActions";
import iconv from "iconv-lite";
import { updateCashJournal } from "../../Services/JournalApi";
import { useUser } from "../../Auth/useUser";
import { signatureRequest } from "../../Shared/homologation/signatureRequest";
import OrderDetailsModal from "../OrderDetails";
import Payment from "./keyboards/Payment";
import { addClientDebit } from "../../Services/ClientApi";
const attractiveTabStyle = {
  textTransform: "none",
  fontWeight: 700,
  fontSize: "0.95rem",
  borderRadius: "10px",
  margin: "0 4px",
  minHeight: "44px",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  color: "#5f6368",

  // The "Active" State
  "&.Mui-selected": {
    backgroundColor: "#1976d2", // Vivid Blue (or your primary brand color)
    color: "#fff", // White text for contrast
    boxShadow: "0px 4px 12px rgba(25, 118, 210, 0.3)", // "Glow" effect
    transform: "scale(1.02)", // Slight pop-out effect
  },
};
const PaymentDrawer = ({
  parametrages,
  items,
  drawerOpen,
  toggleDrawer,
  totalSession,
  cartTotal,
  total,
  previousPayments,
  tabIndex,
  handleTabChange,
  cartItems = [],
  orderItems = [],
  selectedTable,
  organisation,
  occupiedTableData,
  onClearCart,
  setRefresh,
  refresh,
  handleClearTable,
  selectedClient,
  onClientSelect,
  resetClientToDefault,
}) => {
  const [processing, setProcessing] = useState(false);
  // On-screen ticket fallback when "Impression ticket" is off in parametrage caisse
  const [receiptCart, setReceiptCart] = useState(null);
  const [receiptModalOpen, setReceiptModalOpen] = useState(false);
  const activeJournal = JSON.parse(localStorage.getItem("activeJournal"));
  // Add these new states
  const [focusedInput, setFocusedInput] = useState(null);
  const [focusedMethod, setFocusedMethod] = useState(null);
  const [inputValues, setInputValues] = useState({});
  // New payment state management
  const [paymentState, setPaymentState] = useState({
    totalPayment: 0,
    cashPayment: 0,
    creditcardPayment: 0,
    chequePayment: 0,
    giftCardPayment: 0,
    cashRendu: 0,
  });
  const [amountCash, setAmountCash] = useState(0);
  const [amountCheque, setAmountCheque] = useState(0);
  const [amountCard, setAmountCard] = useState(0); // This exists but might not be passed correctly
  const [amountCadeau, setAmountCadeau] = useState(0);
  const [currentPayment, setCurrentPayment] = useState({
    method: "cash",
    amount: 0,
    rendu: 0,
    mobile: "",
    dueDate: "",
    chequeNumber: "",
  });
  const isCreditMode = useRef(false);

  const [creditDialogOpen, setCreditDialogOpen] = useState(false);
  const [creditProcessing, setCreditProcessing] = useState(false);
  const [payments, setPayments] = useState([]);
  const calculateTotal = () => {
    // const cartTotal = cartItems.reduce(
    //   (total, item) => total + item.netPrice,
    //   0,
    // );
    const itemsTotal = items.reduce((total, item) => total + item.netPrice, 0);

    return itemsTotal === totalSession
      ? itemsTotal + parametrages?.timbre
      : itemsTotal;
  };

  const displayTotal = calculateTotal();
  // Calculate remaining amount to pay — rounded to the millime (3 decimals)
  // to avoid floating-point noise (e.g. 0.00000000004) reading as "unpaid"
  // even though it displays as 0.000.
  const remainingAmount =
    Math.round((displayTotal - paymentState.totalPayment) * 1000) / 1000;

  // Check if this is a default table (Comptoir/takeaway)
  const isDefaultTable = selectedTable?.default === true;

  // Map tab indices to payment methods
  const tabToMethod = {
    0: "cash",
    1: "creditcard",
    2: "cheque",
    3: "gift_card", // Add this
  };
  const user = useUser();
  const [infoUser] = useState(user.result);
  // Reset when drawer opens/closes or total changes
  // Reset when drawer opens/closes or total changes
  useEffect(() => {
    if (drawerOpen) {
      setPayments([]);
      setPaymentState({
        totalPayment: 0,
        cashPayment: 0,
        creditcardPayment: 0,
        chequePayment: 0,
        giftCardPayment: 0,
        cashRendu: 0,
      });

      // ✅ ADD THESE - they were missing
      setAmountCash(0);
      setAmountCheque(0);
      setAmountCard(0);
      setAmountCadeau(0);
      setInputValues({}); // ✅ ADD THIS

      const initialMethod = tabToMethod[tabIndex] || "cash";
      setCurrentPayment({
        method: initialMethod,
        amount: 0,
        rendu: 0,
        mobile: "",
        dueDate: "",
        chequeNumber: "",
      });
    }
  }, [drawerOpen, displayTotal]);
  useEffect(() => {
    if (!drawerOpen) {
      setPayments([]);
      setPaymentState({
        totalPayment: 0,
        cashPayment: 0,
        creditcardPayment: 0,
        chequePayment: 0,
        giftCardPayment: 0,
        cashRendu: 0,
      });

      // ✅ ADD THESE - they were missing
      setAmountCash(0);
      setAmountCheque(0);
      setAmountCard(0);
      setAmountCadeau(0);
      setInputValues({}); // ✅ ADD THIS

      // Reset the active tab back to Espèces (cash) so the next order doesn't
      // inherit whatever method was last used (e.g. stays on Chèque otherwise).
      if (tabIndex !== 0) {
        handleTabChange(null, 0);
      }
      setCurrentPayment({
        method: "cash",
        amount: 0,
        rendu: 0,
        mobile: "",
        dueDate: "",
        chequeNumber: "",
      });
    }
  }, [drawerOpen]);
  // Update payment state when individual payments change
  const updatePaymentState = (method, amount, rendu = 0) => {
    setPaymentState((prev) => {
      const newState = {
        ...prev,
        [method + "Payment"]: amount,
        cashRendu: rendu,
      };

      // Calculate total payment
      newState.totalPayment =
        newState.cashPayment +
        newState.creditcardPayment +
        newState.chequePayment +
        newState.giftCardPayment;

      return newState;
    });
  };

  // Handle payment data changes from payment components
  const handlePaymentDataChange = (data, method) => {
    if (isDeletingPayment.current) {
      console.log("Ignoring payment change during deletion");
      return;
    }
    const amount = data.amount || 0;
    const rendu = data.rendu || 0;

    // Update the payment state
    updatePaymentState(method, amount, rendu);

    // Also update current payment for the form
    setCurrentPayment((prev) => ({
      ...prev,
      ...data,
      amount: amount,
    }));

    // Automatically add to payments list if amount > 0
    if (amount > 0) {
      const newPayment = {
        id: Date.now() + method, // Unique ID with method to allow same amount different methods
        method: method,
        amount: amount,
        rendu: rendu,
        mobile: data.mobile || "",
        dueDate: data.dueDate || "",
        chequeNumber: data.chequeNumber || "",
        timestamp: new Date().toLocaleTimeString(),
      };

      // Remove existing payment for this method and add new one
      setPayments((prev) => {
        const filtered = prev.filter((p) => p.method !== method);
        return [...filtered, newPayment];
      });
    } else {
      // Remove payment if amount is 0
      setPayments((prev) => prev.filter((p) => p.method !== method));
    }
  };
  const handleCreditPayment = async () => {
    if (!selectedClient) {
      toast.error("Aucun client sélectionné pour le crédit.");
      return;
    }
    const creditAmount = parseFloat(remainingAmount.toFixed(3));
    if (creditAmount <= 0) return;

    try {
      setCreditProcessing(true);
      const clientId = selectedClient.id || selectedClient._id;
      const debitRes = await addClientDebit(clientId, {
        amount: creditAmount,
        note: `Achat à crédit — caissier: ${infoUser?.nom || infoUser?.id}`,
        created_by: infoUser?.id,
      });
      // Reflect the new credit balance immediately (badge/red background in
      // ClientSelector) instead of waiting for a page reload to refetch it.
      const updatedClient = debitRes?.data?.data?.client;
      if (updatedClient && onClientSelect) {
        onClientSelect({ ...selectedClient, ...updatedClient });
      }
      setCreditDialogOpen(false);
      isCreditMode.current = true;
      await handleFinalPayment();
      isCreditMode.current = false;
    } catch (err) {
      toast.error(
        "Erreur crédit: " + (err.response?.data?.message || err.message),
      );
    } finally {
      setCreditProcessing(false);
    }
  };
  // Update current payment when tab changes
  useEffect(() => {
    const newMethod = tabToMethod[tabIndex] || "cash";
    setCurrentPayment((prev) => ({
      ...prev,
      method: newMethod,
      amount: getCurrentMethodAmount(newMethod),
      // Reset payment-specific fields when changing methods
      ...(newMethod !== "cash" && { rendu: 0 }),
      ...(newMethod !== "cheque" && {
        mobile: "",
        dueDate: "",
        chequeNumber: "",
      }),
    }));
  }, [tabIndex]);
  // Add this useEffect in PaymentDrawer.jsx
  useEffect(() => {
    console.log(
      "Focus effect triggered - tabIndex:",
      tabIndex,
      "drawerOpen:",
      drawerOpen,
    );

    const timer = setTimeout(() => {
      console.log("Attempting to focus...");

      if (tabIndex === 0) {
        const cashInput = document.querySelector('[data-payment="cash"]');
        if (cashInput) cashInput.focus();
      } else if (tabIndex === 1) {
        const cardInput = document.querySelector('[data-payment="creditcard"]');
        if (cardInput) cardInput.focus();
      } else if (tabIndex === 2) {
        const chequeInput = document.querySelector('[data-payment="cheque"]');
        if (chequeInput) {
          // Method 1: Focus and click
          chequeInput.focus();
          chequeInput.click(); // Sometimes click helps

          // Method 2: Set active field in the component
          // You might need to expose a method from ChequePayment
          if (chequeInput._reactInternalInstance) {
            // If you can access the component instance
          }

          // Method 3: Dispatch both events
          window.dispatchEvent(
            new CustomEvent("virtualKeyboardFocus", {
              detail: { method: "cheque", input: "amount" },
            }),
          );
        }
      }
    }, 300); // Increase delay to 300ms

    return () => clearTimeout(timer);
  }, [tabIndex, drawerOpen]);
  // Helper function to get current method amount
  const getCurrentMethodAmount = (method) => {
    switch (method) {
      case "cash":
        return paymentState.cashPayment;
      case "creditcard":
        return paymentState.creditcardPayment;
      case "cheque":
        return paymentState.chequePayment;
      case "gift_card":
        return paymentState.giftCardPayment;
      default:
        return 0;
    }
  };

  // Custom handleTabChange that also updates the payment method
  const handleTabChangeWithMethod = (event, newValue) => {
    handleTabChange(event, newValue);
  };

  // Remove payment from list
  // Remove payment from list
  // Add this ref at the top of your parent component
  const isDeletingPayment = useRef(false);

  const removePayment = (paymentId) => {
    console.log("Removing payment:", paymentId);

    // Set the deleting flag to true
    isDeletingPayment.current = true;

    const paymentToRemove = payments.find((p) => p.id === paymentId);

    if (paymentToRemove) {
      console.log("Method to remove:", paymentToRemove.method);

      // Update payment state by removing this payment
      updatePaymentState(paymentToRemove.method, 0);

      // Clear the current payment
      if (paymentToRemove.method === "cheque") {
        console.log("FORCE clearing cheque payment");

        // Clear current payment
        setCurrentPayment({
          amount: 0,
          rendu: 0,
          mobile: "",
          dueDate: "",
          chequeNumber: "",
        });

        // Clear state values
        setAmountCheque(0);
        setInputValues((prev) => ({
          ...prev,
          cheque_amount: 0,
          cheque_mobile: "",
          cheque_number: "",
        }));

        // Dispatch clear events
        const chequeFields = ["amount", "mobile", "chequeNumber"];
        chequeFields.forEach((field) => {
          const clearEvent = new CustomEvent("virtualKeyboardInput", {
            detail: {
              method: "cheque",
              input: field,
              value: field === "amount" ? "0" : "",
            },
          });
          window.dispatchEvent(clearEvent);
        });
      } else {
        // Handle other payment methods
        setCurrentPayment((prev) => ({
          ...prev,
          amount: 0,
          rendu: 0,
        }));
      }

      // Clear method-specific states
      if (paymentToRemove.method === "cash") {
        setAmountCash(0);
        setInputValues((prev) => ({ ...prev, cash_amount: 0 }));
      } else if (paymentToRemove.method === "creditcard") {
        setAmountCard(0);
        setInputValues((prev) => ({ ...prev, creditcard_amount: 0 }));
      } else if (paymentToRemove.method === "cheque") {
        setAmountCheque(0);
        setInputValues((prev) => ({ ...prev, cheque_amount: 0 }));
      } else if (paymentToRemove.method === "gift_card") {
        setAmountCadeau(0);
        setInputValues((prev) => ({ ...prev, gift_card_amount: 0 }));
      }
    }

    // Remove the payment from the list
    setPayments((prev) => {
      const newPayments = prev.filter((p) => p.id !== paymentId);
      console.log("New payments:", newPayments);

      // Reset the deleting flag after a short delay
      setTimeout(() => {
        isDeletingPayment.current = false;
      }, 100);

      return newPayments;
    });
  };
  // Function to create cart and process payment for default table

  const callImpression = async (dataTicket, type) => {
    const lines = ImpressionTicket(type, {
      ...dataTicket,
    });

    const finalBuffer = (() => {
      const allBytes = [];
      // treat `lines` as string
      const buf = iconv.encode(lines, "ISO-8859-1");
      allBytes.push(...buf);
      return new Uint8Array(allBytes);
    })();
    await PrintAction(finalBuffer, true);
  };

  // Prints the ticket as before, unless "Impression ticket" is turned off in
  // parametrage caisse — then it's shown on screen instead of printed. Either
  // way, a completed payment must still kick the cash drawer open.
  const issueTicket = (dataTicket, type) => {
    if (parametrages?.impressionTicket === false) {
      setReceiptCart(buildReceiptCart(dataTicket, type));
      // setReceiptModalOpen(true);
      if (type === "payment") {
        PrintAction(null, true, false);
      }
      return;
    }
    callImpression(dataTicket, type);
  };

  const updateFondCourant = async (totalCash) => {
    try {
      const journalId = activeJournal.id;
      const currentfund = Number(activeJournal.fond_courant);
      console.log("currentfund", currentfund, "totalCash", totalCash);

      const res = await updateCashJournal(journalId, {
        fond_courant: currentfund + Number(totalCash),
      });
      if (res.data.success) {
        // Remove old value
        localStorage.removeItem("activeJournal");

        // Save updated journal object from backend
        localStorage.setItem("activeJournal", JSON.stringify(res.data.data));
      }
      if (res?.status === 200) {
        console.log("Fond courant updated successfully");

        // 5. Update localStorage
        const currentFond =
          parseFloat(localStorage.getItem("fond_courant") || "0") || 0;

        const newFond = currentFond + totalCash;

        console.log("Local fond courant updated:", newFond);
      } else {
        console.error("Error updating cash journal:", res);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };
  const handleDefaultTablePayment = async () => {
    if (processing) return;

    if (!selectedTable) {
      toast.warning("Aucune table sélectionnée!");
      return;
    }

    if (!organisation) {
      toast.warning("Organisation non définie!");
      return;
    }

    if (cartItems.length === 0) {
      toast.warning("Le panier est vide!");
      return;
    }

    // Check if total is paid
    if (!isCreditMode.current && remainingAmount > 0) {
      toast.warning(
        `Montant insuffisant! Reste à payer: ${remainingAmount.toFixed(3)} TND`,
      );
      return;
    }

    try {
      setProcessing(true);
      console.log(selectedTable);
      // Prepare cart data for default table
      const cartData = {
        table_id: selectedTable._id || selectedTable.id,
        organisation_id: organisation,
        journal_id: activeJournal._id || activeJournal.id,
        numero: activeJournal.sequence,
        produits: cartItems.map((item) => ({
          product: item.productInfo,
          ingredients: item.ingredients
            ? item.ingredients.map((ingredient) => ingredient.id)
            : [],
          quantity: item.quantity,
          price: item.price,
          totalPrice: item.totalPrice,
          remise: item.remise,
          netPrice: item.netPrice,
        })),
        prix: displayTotal,
        takeAway: true,
        caissier_id: infoUser.id,
        client_id: selectedClient?.id || selectedClient?._id || null,
      };

      console.log("Creating cart for default table:", cartData);

      // First, create the cart
      const cartResponse = await addCart(cartData);

      if (cartResponse.data.success !== "0") {
        const result = cartResponse.data.data;
        console.log("Cart created for default table:", result);

        // If cart creation successful, now process payments
        if (result.session && result.cart) {
          const session = result.session;

          // Prepare payment and transaction data
          const paymentRequests = [
            ...(paymentState.cashPayment > 0
              ? [
                  {
                    payment_method: "cash",
                    amount: paymentState.cashPayment,
                    rendu: paymentState.cashRendu,
                    transaction_type: "vente",
                    journal_id: activeJournal._id || activeJournal.id,
                  },
                ]
              : []),
            ...(paymentState.creditcardPayment > 0
              ? [
                  {
                    payment_method: "creditcard",
                    amount: paymentState.creditcardPayment,
                    rendu: 0,
                    transaction_type: "vente",
                    journal_id: activeJournal._id || activeJournal.id,
                  },
                ]
              : []),
            ...(paymentState.chequePayment > 0
              ? [
                  {
                    payment_method: "cheque",
                    amount: paymentState.chequePayment,
                    rendu: 0,
                    transaction_type: "vente",
                    mobile: currentPayment.mobile,
                    due_date: currentPayment.dueDate,
                    cheque_number: currentPayment.chequeNumber,
                    journal_id: activeJournal._id || activeJournal.id,
                  },
                ]
              : []),
            ...(paymentState.giftCardPayment > 0
              ? [
                  {
                    payment_method: "gift_card",
                    amount: paymentState.giftCardPayment,
                    rendu: 0,
                    transaction_type: "vente",
                    journal_id: activeJournal._id || activeJournal.id,
                  },
                ]
              : []),
          ];

          const transactions = paymentRequests.map((payment) => ({
            amount: payment.amount - payment.rendu,
            journal_id: activeJournal._id || activeJournal.id,
            caissier_id: infoUser.id,

            payment_method: payment.payment_method,
            transaction_type: "vente",
            sens: "credit",
            notes: ``,
          }));
          // 2. Filter CASH ONLY transactions
          const cashTransactions = transactions.filter(
            (t) => t.payment_method?.toLowerCase() === "cash",
          );

          // 3. Sum the amounts
          const totalCash = cashTransactions.reduce(
            (sum, t) => sum + t.amount,
            0,
          );
          updateFondCourant(totalCash);
          // Process payments for the newly created session
          const paymentRequest = {
            ticket: {
              organisation_id: organisation,
              journal_id: activeJournal._id || activeJournal.id,
              table_session: session._id,
              items: items,
              type: total === totalSession ? "total" : "partial",
              total: displayTotal,
            },
            table_session_id: session._id,
            payments: paymentRequests,
            transactions: transactions,
            caissier_id: infoUser.id,
          };

          console.log("Processing payments for default table:", paymentRequest);

          const paymentResponse =
            await closeTableSessionAndPayAll(paymentRequest);

          if (paymentResponse.data.success !== "0") {
            toast.success("Commande et paiement effectués avec succès!");
            console.log("response.data", paymentResponse.data);
            const convertedCarts = convertCartsToCartItems(
              paymentResponse.data.data.paid_carts,
              parametrages.grouping_products,
            );
            console.log("convertedCarts", convertedCarts);

            const data = {
              serveur: paymentResponse.data.data.table_session.serveur,
              // transactions is empty when the balance is settled entirely on
              // credit (no cash/card/cheque/gift_card row is ever created for
              // that), so fall back to the session's caissier in that case.
              caissier:
                paymentResponse.data.data.transactions?.[0]?.caissier ||
                paymentResponse.data.data.table_session.caissier,
              carts: convertedCarts,
              payments: paymentResponse.data.data.payments,
              table: paymentResponse.data.data.table_session.table,
              table_session: paymentResponse.data.data.table_session,
              total: paymentResponse.data.data.total,
              HT: calculateReceiptByTVA(convertedCarts),
              restaurant: restaurant,
              timbre: parametrages?.timbre || 0,
              acompte:
                total === totalSession && previousPayments.length
                  ? previousPayments.reduce(
                      (sum, transaction) => sum + transaction.amount,
                      0,
                    )
                  : 0,
            };
            console.log("dataaaaaaaaa", data);
            issueTicket(data, "payment");
            signatureRequest(data);
            // toast.success("Paiement effectué avec succès! Session fermée.");
            // Clear everything and refresh
            if (onClearCart) {
              onClearCart();
            }
            if (resetClientToDefault) {
              // ADD THIS BLOCK
              resetClientToDefault();
            }
            if (setRefresh) {
              setRefresh(!refresh);
            }

            // Close drawer
            toggleDrawer(false)();

            // Reset payments
            setPayments([]);
            handleClearTable();
            setPaymentState({
              totalPayment: 0,
              cashPayment: 0,
              creditcardPayment: 0,
              chequePayment: 0,
              giftCardPayment: 0,
              cashRendu: 0,
            });
          } else {
            toast.error(
              "Erreur lors du paiement: " +
                (paymentResponse.data.message || "Unknown error"),
            );
          }
        } else {
          toast.error("Erreur: Session non créée pour la table par défaut");
        }
      } else {
        toast.error("Erreur lors de la création de la commande");
      }
    } catch (error) {
      console.error("Default table payment error:", error);
      toast.error(
        "Erreur lors du traitement: " +
          (error.response?.data?.message || error.message),
      );
    } finally {
      setProcessing(false);
    }
  };
  // Function to handle final payment submission
  const restaurant = JSON.parse(localStorage.getItem("organisations"))[0];

  const handleFinalPayment = async () => {
    // For default tables, use the combined create-and-pay flow
    if (isDefaultTable) {
      await handleDefaultTablePayment();
      return;
    }

    // For occupied tables, use the existing flow
    if (processing) return;

    // Validate if we have a table session to pay
    if (!occupiedTableData || !occupiedTableData.session) {
      await handleDefaultTablePayment();
      return;
    }

    if (!selectedTable) {
      toast.warning("Aucune table sélectionnée!");
      return;
    }

    if (!organisation) {
      toast.warning("Organisation non définie!");
      return;
    }

    // Check if total is paid
    if (!isCreditMode.current && remainingAmount > 0) {
      toast.warning(
        `Montant insuffisant! Reste à payer: ${remainingAmount.toFixed(3)} TND`,
      );
      return;
    }

    try {
      setProcessing(true);

      const session = occupiedTableData.session;

      // Prepare payment and transaction data for the entire session
      const paymentRequests = [
        ...(paymentState.cashPayment > 0
          ? [
              {
                payment_method: "cash",
                amount: paymentState.cashPayment,
                rendu: paymentState.cashRendu,
                transaction_type: "vente",
                journal_id: activeJournal._id || activeJournal.id,
              },
            ]
          : []),
        ...(paymentState.creditcardPayment > 0
          ? [
              {
                payment_method: "creditcard",
                amount: paymentState.creditcardPayment,
                rendu: 0,
                transaction_type: "vente",
                journal_id: activeJournal._id || activeJournal.id,
              },
            ]
          : []),
        ...(paymentState.chequePayment > 0
          ? [
              {
                payment_method: "cheque",
                amount: paymentState.chequePayment,
                rendu: 0,
                transaction_type: "vente",
                mobile: currentPayment.mobile,
                date_echeance_cheque: currentPayment.dueDate,
                numero_cheque: currentPayment.chequeNumber,
                journal_id: activeJournal._id || activeJournal.id,
              },
            ]
          : []),
        ...(paymentState.giftCardPayment > 0
          ? [
              {
                payment_method: "gift_card",
                amount: paymentState.giftCardPayment,
                rendu: 0,
                transaction_type: "vente",
                journal_id: activeJournal._id || activeJournal.id,
              },
            ]
          : []),
      ];

      const transactions = paymentRequests.map((payment) => ({
        amount: payment.amount - payment.rendu,
        payment_method: payment.payment_method,
        transaction_type: "vente",
        sens: "credit",
        notes: ``,
        journal_id: activeJournal._id || activeJournal.id,
      }));

      // 2. Filter CASH ONLY transactions
      const cashTransactions = transactions.filter(
        (t) => t.payment_method?.toLowerCase() === "cash",
      );

      // 3. Sum the amounts
      const totalCash = cashTransactions.reduce((sum, t) => sum + t.amount, 0);
      updateFondCourant(totalCash);
      // Use the correct format for session payment
      const paymentRequest = {
        ticket: {
          organisation_id: organisation,
          journal_id: activeJournal._id || activeJournal.id,
          table_session: session._id,
          items: items,
          type: total === totalSession ? "total" : "partial",
          total: displayTotal,
        },
        table_session_id: session._id,
        payments: paymentRequests,
        transactions: transactions,
        caissier_id:
          infoUser.role === "caissier" || infoUser.role === "admin"
            ? infoUser.id
            : null,
        serveur_id: infoUser.role === "serveur" ? infoUser.id : null,
      };

      console.log("Sending multi-payment request:", paymentRequest);

      // Make API call
      const response = await closeTableSessionAndPayAll(paymentRequest);

      if (response.data.success !== "0") {
        console.log("response.data", response.data);
        console.log("iteeeeeeeeems", items);

        const convertedCarts = convertCartsToCartItems(
          response.data.data.paid_carts.length
            ? response.data.data.paid_carts
            : items,
          parametrages.grouping_products,
        );
        console.log("convertedCarts", convertedCarts);
        let data = {};
        if (total === totalSession) {
          data = {
            serveur: response.data.data.table_session.serveur,
            // transactions is empty when settled entirely on credit — fall
            // back to the session's caissier in that case.
            caissier:
              response.data.data.transactions?.[0]?.caissier ||
              response.data.data.table_session.caissier,
            carts: convertedCarts,
            payments: response.data.data.payments,
            table: response.data.data.table_session.table,
            table_session: response.data.data.table_session,
            total: response.data.data.total,
            HT: calculateReceiptByTVA(convertedCarts),
            restaurant: restaurant,
            timbre: parametrages?.timbre || 0,
            acompte:
              total === totalSession && previousPayments.length
                ? previousPayments.reduce(
                    (sum, transaction) => sum + transaction.amount,
                    0,
                  )
                : 0,
          };
        } else {
          data = {
            serveur: response.data.data.table_session.serveur,
            // transactions is empty when settled entirely on credit — fall
            // back to the session's caissier in that case.
            caissier:
              response.data.data.transactions?.[0]?.caissier ||
              response.data.data.table_session.caissier,
            carts: items,
            payments: response.data.data.payments,
            table: response.data.data.table_session.table,
            table_session: response.data.data.table_session,
            total: total,
            HT: calculateReceiptByTVA(items),
            restaurant: restaurant,
            timbre: parametrages?.timbre || 0,
            acompte:
              total === totalSession && previousPayments.length
                ? previousPayments.reduce(
                    (sum, transaction) => sum + transaction.amount,
                    0,
                  )
                : 0,
          };
        }

        console.log("dataaaaaaaaa", data);
        issueTicket(data, "payment");
        signatureRequest(data);
        toast.success("Paiement effectué avec succès! Session fermée.");

        // Clear everything and refresh
        if (onClearCart) {
          onClearCart();
        }
        if (resetClientToDefault) {
          // ADD THIS BLOCK
          resetClientToDefault();
        }
        if (setRefresh) {
          setRefresh(!refresh);
        }

        // Close drawer
        toggleDrawer(false)();

        // Reset payments
        setPayments([]);
        handleClearTable();
        setPaymentState({
          totalPayment: 0,
          cashPayment: 0,
          creditcardPayment: 0,
          chequePayment: 0,
          giftCardPayment: 0,
          cashRendu: 0,
        });
      } else {
        toast.error(
          "Erreur lors du paiement: " +
            (response.data.message || "Unknown error"),
        );
      }
    } catch (error) {
      console.error("Payment error:", error);

      if (error.response) {
        console.error("Error response:", error.response.data);
        console.error("Error status:", error.response.status);
      }

      toast.error(
        "Erreur lors du paiement: " +
          (error.response?.data?.message || error.message),
      );
    } finally {
      setProcessing(false);
    }
  };

  const getMethodLabel = (method) => {
    const labels = {
      cash: "Espèces",
      creditcard: "Carte Bancaire",
      cheque: "Chèque",
      gift_card: "Carte Cadeau",
    };
    return labels[method] || method;
  };

  const getMethodColor = (method) => {
    const colors = {
      cash: "success",
      creditcard: "primary",
      cheque: "warning",
      gift_card: "secondary", // or "info"
    };
    return colors[method] || "default";
  };

  const handleKeyPress = (key) => {
    if (!focusedInput || !focusedMethod) return;

    // Update the specific payment component's input
    const inputId = `${focusedMethod}_${focusedInput}`;
    const currentValue = inputValues[inputId] || "";

    let newValue = currentValue;

    if (key === "←") {
      // Backspace
      newValue = currentValue.slice(0, -1);
    } else if (key === "✔") {
      // Validate/Enter - could trigger calculation or just blur
      document.activeElement.blur();
      return;
    } else {
      // Add character
      newValue = currentValue + key;
    }

    // Update local state
    setInputValues((prev) => ({
      ...prev,
      [inputId]: newValue,
    }));

    // Trigger the change in the payment component
    // We'll use a custom event or callback to communicate with payment components
    const event = new CustomEvent("virtualKeyboardInput", {
      detail: {
        method: focusedMethod,
        input: focusedInput,
        value: newValue,
      },
    });
    window.dispatchEvent(event);
  };

  // Function to handle input focus from payment components
  const handleInputFocus = (method, inputName) => {
    setFocusedMethod(method);
    setFocusedInput(inputName);
  };

  // Function to handle input blur
  const handleInputBlur = () => {
    // Optional: clear focus or keep last focused input
  };
  const [showLetters, setShowLetters] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  // Add this useEffect in PaymentDrawer.jsx
  // Add this near your other useEffects in PaymentDrawer.jsx
  useEffect(() => {
    const handleVirtualKeyboardFocus = (event) => {
      const { method, input } = event.detail;
      setFocusedMethod(method);
      setFocusedInput(input);

      // Small delay to ensure the input has rendered and keyboard is open
      setTimeout(() => {
        // Find the focused input element
        const focusedElement = document.querySelector(
          "input:focus, textarea:focus, [tabindex='0']:focus",
        );
        if (focusedElement) {
          // Scroll the element into view smoothly
          focusedElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 300);
    };

    window.addEventListener("virtualKeyboardFocus", handleVirtualKeyboardFocus);

    return () => {
      window.removeEventListener(
        "virtualKeyboardFocus",
        handleVirtualKeyboardFocus,
      );
    };
  }, []); // Empty dependency array is fine here

  return (
    <>
    <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
      <div
        style={{
          width: 600,
          height: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header - Fixed */}
        <div
          className="box-header bg-info"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexShrink: 0,
            padding: "10px 15px",
          }}
        >
          <h4 className="box-title" onClick={() => console.log(items)}>
            {selectedTable && (
              <div
                className="table-display-header"
                style={{
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "16px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  backgroundColor: "rgba(255,255,255,0.2)",
                  padding: "5px 10px",
                  borderRadius: "4px",
                }}
              >
                <span>{"Paiement"}</span>
              </div>
            )}
          </h4>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
            }}
          >
            {/* Total Display */}
            <div
              className="cart-total-header"
              style={{
                color: "white",
                fontWeight: "bold",
                fontSize: "18px",
              }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  onClick={() => console.log(items)}
                >
                  {"Total: " + displayTotal.toFixed(3)} TND
                </Typography>
              </Box>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
            }}
          >
            {/* Total Display */}
            <div
              className="cart-total-header"
              style={{
                color: "white",
                fontWeight: "bold",
                fontSize: "18px",
                display: "flex",
              }}
            >
              {remainingAmount > 0 && (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="h6" fontWeight="bold">
                    {"Reste: " + remainingAmount.toFixed(3)} TND{" "}
                  </Typography>
                </Box>
              )}
              {/* Cash Rendu Display */}
              {remainingAmount < 0 && (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="h6" fontWeight="bold">
                    {"Rendu: " + remainingAmount.toFixed(3)} TND
                  </Typography>
                </Box>
              )}
              <button
                className="btn btn-xs btn-outline-light"
                onClick={toggleDrawer(false)}
                style={{
                  padding: "5px 10px",
                  fontSize: "12px",
                  marginLeft: "5px",
                }}
                title="Changer de table"
              >
                <i className="fas fa-times"></i>
              </button>{" "}
            </div>
          </div>
        </div>

        {/* Scrollable Content Area */}
        <div style={{ flex: 1, overflowY: "auto" }}>
          <div className="box-body p-1">
            {payments.length > 0 && (
              <Card sx={{ mb: 2 }}>
                <CardContent sx={{ py: 1, "&:last-child": { pb: 1 } }}>
                  <Box display="flex" flexWrap="wrap" gap={1}>
                    {payments.map((payment) => (
                      <Chip
                        key={payment.id}
                        variant="outlined"
                        size="small"
                        color={getMethodColor(payment.method)}
                        label={`${getMethodLabel(payment.method)}: ${payment.amount.toFixed(3)} TND`}
                        onDelete={
                          processing
                            ? undefined
                            : () => removePayment(payment.id)
                        }
                        sx={{ bgcolor: "#f5f5f5" }}
                      />
                    ))}
                  </Box>
                </CardContent>
              </Card>
            )}

            {/* {!isDefaultTable && !occupiedTableData && (
              <div className="alert alert-warning mt-3">
                <strong>Information:</strong> Sélectionnez d'abord une table
                occupée pour effectuer le paiement.
              </div>
            )} */}

            {/* Payment Method Selection */}
            <Tabs
              value={tabIndex}
              onChange={handleTabChangeWithMethod}
              variant="fullWidth"
              TabIndicatorProps={{ style: { display: "none" } }} // Hide the line
              sx={{
                backgroundColor: "#f0f2f5", // Soft background
                borderRadius: "12px",
                padding: "6px",
                minHeight: "54px",
                boxShadow: "inset 0px 2px 4px rgba(0,0,0,0.05)", // Inner shadow for "depth"
              }}
            >
              <Tab label="Espèces" sx={attractiveTabStyle} />
              <Tab label="C.bancaire" sx={attractiveTabStyle} />
              <Tab label="Chèque" sx={attractiveTabStyle} />
            </Tabs>

            {/* Current Payment Input */}
            <Box mt={2}>
              {tabIndex === 0 && (
                <CashPayment
                  total={displayTotal}
                  totalPaid={paymentState.totalPayment}
                  onPaymentDataChange={(data) =>
                    handlePaymentDataChange(data, "cash")
                  }
                  currentPayment={currentPayment}
                  processing={processing}
                  disabled={
                    (!occupiedTableData && !isDefaultTable) ||
                    remainingAmount <= 0
                  }
                  amountCash={amountCash}
                  setAmountCash={setAmountCash}
                  parametrage={parametrages}
                />
              )}
              {tabIndex === 1 && (
                <CreditCardPayment
                  total={remainingAmount}
                  onPaymentDataChange={(data) =>
                    handlePaymentDataChange(data, "creditcard")
                  }
                  currentPayment={currentPayment}
                  processing={processing}
                  disabled={
                    (!occupiedTableData && !isDefaultTable) ||
                    remainingAmount <= 0
                  }
                  amountCard={amountCard} // Add this
                  setAmountCard={setAmountCard} // Add this
                />
              )}
              {tabIndex === 2 && (
                <ChequePayment
                  total={remainingAmount}
                  onPaymentDataChange={(data) =>
                    handlePaymentDataChange(data, "cheque")
                  }
                  currentPayment={currentPayment} // Make sure this is passed
                  processing={processing}
                  disabled={
                    (!occupiedTableData && !isDefaultTable) ||
                    remainingAmount <= 0
                  }
                />
              )}
              {tabIndex === 3 && (
                <GiftCardPayment
                  total={remainingAmount}
                  onPaymentDataChange={(data) =>
                    handlePaymentDataChange(data, "gift_card")
                  }
                  currentPayment={currentPayment}
                  processing={processing}
                  disabled={
                    (!occupiedTableData && !isDefaultTable) ||
                    remainingAmount <= 0
                  }
                />
              )}
            </Box>
          </div>
        </div>
        {remainingAmount > 0 && (
          <div
            style={{
              color: "#f44336",
              fontSize: "14px",
              textAlign: "center",
            }}
          >
            Montant insuffisant: il manque {remainingAmount.toFixed(3)} TND
          </div>
        )}
        {/* Footer with Buttons and Virtual Keyboard - Fixed at Bottom */}
        <div style={{ flexShrink: 0, padding: "0 20px 20px 20px" }}>
          <div
            className="box-footer"
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {/* Final Payment Button */}
            {/* Button row */}
            <Box display="flex" gap={1}>
              {/* Credit button — only when underpaid and a real client is selected */}
              {remainingAmount > 0 &&
              selectedClient &&
              !selectedClient.isDefault &&
              !selectedClient.isBlocked ? (
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => setCreditDialogOpen(true)}
                  disabled={processing}
                  size="large"
                  sx={{
                    flex: "0 0 auto",
                    minWidth: "130px",
                    backgroundColor: "#e65100",
                    "&:hover": { backgroundColor: "#bf360c" },
                    fontWeight: 700,
                  }}
                >
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    lineHeight={1.2}
                  >
                    <span style={{ fontSize: "13px" }}>CRÉDIT</span>
                    <span style={{ fontSize: "11px", opacity: 0.85 }}>
                      {remainingAmount.toFixed(3)} TND
                    </span>
                  </Box>
                </Button>
              ) : (
                <Button
                  fullWidth
                  variant="contained"
                  color="success"
                  onClick={handleFinalPayment}
                  disabled={processing || remainingAmount > 0}
                  size="large"
                >
                  {processing
                    ? "Traitement en cours..."
                    : isDefaultTable
                      ? `Confirmer Commande & Paiement (${paymentState.totalPayment.toFixed(3)} TND)`
                      : remainingAmount <= 0
                        ? `Confirmer le Paiement Complet (${paymentState.totalPayment.toFixed(3)} TND)`
                        : `Payer ${paymentState.totalPayment.toFixed(3)}/${displayTotal.toFixed(3)} TND`}
                </Button>
              )}

              {/* Existing confirm button — unchanged, just wrapped in Box */}
            </Box>
            {/* Virtual Keyboard - Always visible at bottom */}
            <Payment
              onKeyPress={handleKeyPress}
              showLetters={showLetters}
              setShowLetters={setShowLetters}
              disabled={isProcessing}
              compact={true}
              context="numeric"
            />
          </div>
        </div>
      </div>
      <Dialog
        open={creditDialogOpen}
        onClose={() => !creditProcessing && setCreditDialogOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "12px", overflow: "hidden" } }}
      >
        <Box
          sx={{
            backgroundColor: "#e65100",
            px: 3,
            py: 2,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
          }}
        >
          <Typography variant="h6" fontWeight={700} color="#fff">
            Confirmer le Crédit
          </Typography>
        </Box>

        <DialogContent sx={{ pt: 3, pb: 1 }}>
          <Box
            sx={{
              mb: 2.5,
              p: 1.5,
              backgroundColor: "#fff8f5",
              borderRadius: "8px",
              border: "1px solid #ffccbc",
            }}
          >
            <Typography variant="caption" color="text.secondary">
              Client
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {selectedClient?.name}
              {selectedClient?.code && (
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "11px",
                    color: "#e65100",
                  }}
                >
                  [{selectedClient.code}]
                </span>
              )}
            </Typography>
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Le client va emporter la commande et réglera le montant restant
            ultérieurement.
          </Typography>

          <Divider sx={{ mb: 2 }} />

          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" justifyContent="space-between">
              <Typography color="text.secondary">Total commande</Typography>
              <Typography fontWeight={600}>
                {displayTotal.toFixed(3)} TND
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography color="text.secondary">Montant payé</Typography>
              <Typography fontWeight={600} color="success.main">
                {paymentState.totalPayment.toFixed(3)} TND
              </Typography>
            </Box>
            <Divider />
            <Box display="flex" justifyContent="space-between">
              <Typography fontWeight={700}>Montant à crédit</Typography>
              <Typography fontWeight={700} color="#e65100" fontSize="1.1rem">
                {remainingAmount.toFixed(3)} TND
              </Typography>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
          <Button
            onClick={() => setCreditDialogOpen(false)}
            disabled={creditProcessing}
            variant="outlined"
            color="inherit"
            sx={{ flex: 1 }}
          >
            Annuler
          </Button>
          <Button
            onClick={handleCreditPayment}
            disabled={creditProcessing}
            variant="contained"
            sx={{
              flex: 1,
              backgroundColor: "#e65100",
              "&:hover": { backgroundColor: "#bf360c" },
              fontWeight: 700,
            }}
          >
            {creditProcessing ? "Traitement..." : "Oui, à crédit"}
          </Button>
        </DialogActions>
      </Dialog>
    </Drawer>

    <OrderDetailsModal
      open={receiptModalOpen}
      onClose={() => setReceiptModalOpen(false)}
      cart={receiptCart}
      currency="TND"
    />
    </>
  );
};

export default PaymentDrawer;
